import { render } from "./RequiredAction.vue?vue&type=template&id=59141b30"
import script from "./RequiredAction.vue?vue&type=script&lang=js"
export * from "./RequiredAction.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./RequiredAction.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_8bb40abb%2Fpackages%2Fcustomer%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Faction%2FRequiredAction.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__